import React from "react";

export function AutoBIMLogo({ size = 36 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      className="shrink-0 shadow-lg shadow-primary/30"
      style={{ borderRadius: size * 0.226 }}
      role="img"
      aria-label="AutoBIM Logic"
    >
      <defs>
        <linearGradient id="ablTile" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#0F1C26" />
          <stop offset="1" stopColor="#0A0D12" />
        </linearGradient>
        <linearGradient id="ablWall" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#7FE7F7" />
          <stop offset="1" stopColor="#00B4D8" />
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="116" fill="url(#ablTile)" />
      {/* outer walls */}
      <rect x="108" y="112" width="296" height="252" rx="10" fill="#0B141B"
            stroke="url(#ablWall)" strokeWidth="15" strokeLinejoin="round" />
      {/* interior partitions: 4 rooms + central corridor */}
      <g stroke="url(#ablWall)" strokeWidth="11" strokeLinecap="round">
        <line x1="108" y1="220" x2="176" y2="220" /><line x1="212" y1="220" x2="256" y2="220" />
        <line x1="256" y1="220" x2="300" y2="220" /><line x1="336" y1="220" x2="404" y2="220" />
        <line x1="108" y1="256" x2="176" y2="256" /><line x1="212" y1="256" x2="300" y2="256" />
        <line x1="336" y1="256" x2="404" y2="256" />
        <line x1="256" y1="112" x2="256" y2="220" />
        <line x1="180" y1="256" x2="180" y2="364" />
        <line x1="332" y1="256" x2="332" y2="364" />
      </g>
      {/* windows */}
      <g>
        <rect x="150" y="105" width="54" height="14" rx="3" fill="#0E2530" stroke="#7FE7F7" strokeWidth="2.5" />
        <line x1="150" y1="112" x2="204" y2="112" stroke="#7FE7F7" strokeWidth="2.5" />
        <rect x="308" y="105" width="54" height="14" rx="3" fill="#0E2530" stroke="#7FE7F7" strokeWidth="2.5" />
        <line x1="308" y1="112" x2="362" y2="112" stroke="#7FE7F7" strokeWidth="2.5" />
        <rect x="101" y="150" width="14" height="52" rx="3" fill="#0E2530" stroke="#7FE7F7" strokeWidth="2.5" />
        <line x1="108" y1="150" x2="108" y2="202" stroke="#7FE7F7" strokeWidth="2.5" />
        <rect x="397" y="286" width="14" height="52" rx="3" fill="#0E2530" stroke="#7FE7F7" strokeWidth="2.5" />
        <line x1="404" y1="286" x2="404" y2="338" stroke="#7FE7F7" strokeWidth="2.5" />
      </g>
      {/* interior doors */}
      <path d="M300 220 L300 190 A30 30 0 0 1 330 220" fill="none" stroke="#DFF9FF" strokeOpacity="0.85" strokeWidth="4.5" strokeLinecap="round" />
      <path d="M212 256 L212 286 A30 30 0 0 0 182 256" fill="none" stroke="#DFF9FF" strokeOpacity="0.85" strokeWidth="4.5" strokeLinecap="round" />
      {/* main entrance */}
      <rect x="228" y="354" width="60" height="20" fill="#0B141B" />
      <path d="M228 364 L228 312 A52 52 0 0 1 280 364" fill="none" stroke="#DFF9FF" strokeOpacity="0.9" strokeWidth="5" strokeLinecap="round" />
      <g stroke="#7FE7F7" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="258" y1="392" x2="258" y2="336" />
        <polyline points="246,352 258,334 270,352" fill="none" />
      </g>
      {/* AI generative hub */}
      <rect x="212" y="210" width="88" height="60" rx="15" fill="#0C1922" stroke="url(#ablWall)" strokeWidth="6" />
      <text x="256" y="257" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="42" fontWeight="900" fill="#F2FFFE" letterSpacing="2">AI</text>
      <g stroke="#F2FFFE" strokeWidth="5.5" strokeLinecap="round">
        <line x1="296" y1="199" x2="296" y2="221" /><line x1="285" y1="210" x2="307" y2="210" />
      </g>
      <circle cx="296" cy="210" r="2.8" fill="#0C1922" />
      {/* dimensions */}
      <g stroke="#63D8EE" strokeWidth="3.5" strokeLinecap="round">
        <line x1="108" y1="404" x2="404" y2="404" />
        <line x1="108" y1="395" x2="108" y2="413" /><line x1="404" y1="395" x2="404" y2="413" />
        <line x1="256" y1="397" x2="256" y2="411" />
        <line x1="80" y1="112" x2="80" y2="364" />
        <line x1="71" y1="112" x2="89" y2="112" /><line x1="71" y1="364" x2="89" y2="364" />
      </g>
      <polygon points="108,404 126,396 126,412" fill="#63D8EE" />
      <polygon points="404,404 386,396 386,412" fill="#63D8EE" />
      <polygon points="80,112 72,130 88,130" fill="#63D8EE" />
      <polygon points="80,364 72,346 88,346" fill="#63D8EE" />
    </svg>
  );
}

export function Wordmark({ small }) {
  return (
    <span className={small ? "text-sm font-black" : "text-lg font-black"}>
      AutoBIM<span className="italic text-accent"> Logic</span>
    </span>
  );
}

export const BRAND = {
  tagline: "Automate BIM · Engineer with Logic",
  taglineAr: "أتمتة الـBIM بمنطق هندسي",
};
